module.exports = __webpack_public_path__ + "img/28.cd301f0f.png";